module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray@3x-039b7aa2d24c2aa94d550be947bd392d.png";